import { getSkuGuide } from '@/api/order';
const actions = {
  // 订单成功后跳转引导  1: 无； 2: 引导下载； 3: 引导加群； 4: 自定义页面； 5: 直播课加群/加老师； 6: 一元购； 7: 训练营加群/加老师
  async acSetGoodsOrderSuccessGuide({ dispatch, commit, state, rootState, rootGetters }, { orderSystemId }) {
    const result = await getSkuGuide({ systemOrderId: orderSystemId });
    return result;
  },
};
export default actions;
